/* BI-09 · INVITE
   The invitation states what the role can and cannot do, in the merchant’s
   terms, before it is sent. */
import { Button, Card, Field, Input } from '@/ui'
import { Head } from './ParamShell'

export default function BI09Inviter() {
  return (
    <section data-frame="BI-09" style={{ display: 'grid', gap: 14 }}>
      <Head title="Inviter un membre" />
      <Field label="E-mail">{id => <Input id={id} />}</Field>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
        <Field label="Rôle">{id => <Input id={id} />}</Field>
        <Field label="Établissements">{id => <Input id={id} />}</Field>
      </div>
      <Card>
        Ce rôle peut : valider des cadeaux, voir le minimum client nécessaire. Ne peut pas :
        campagnes, clients, facturation, autres établissements.
      </Card>
      <div><Button variant="primary">Envoyer l’invitation</Button></div>
    </section>
  )
}
